import { AladdinDataPackages } from '@blk/aw-bff-typescript-models';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { awBffApi } from './Base';

export async function getClientConfigurationListApi() {
  const path = '/packages/list';
  const response = await awBffApi.get<AGraphWrappedType<AladdinDataPackages[], 'packages'>>(path);
  return unwrapAGraphResponse(response, 'packages');
}

export function getClientConfigurationListPRD() {
  const path = '/packages/list/prd';
  return awBffApi.get<AladdinDataPackages[]>(path);
}
